import React from "react";
import Time from "../../containerSmall/time/time.component.jsx";
import UserInfo from "../../containerSmall/userInfo/userInfo.component.jsx";
import { FixeInfoStyled } from "./fixedInfo.styles.js";

const FixedLeft = () => {
  return (
    <FixeInfoStyled>
      <UserInfo />
      {/* <div>asdf</div> */}
      {/* <div>asdf</div> */}
      <Time />
    </FixeInfoStyled>
  );
};

export default FixedLeft;
